import React, { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { SvgIconProps } from "@mui/material/SvgIcon";

import { useStore } from "csi/state/hooks";

/* TODO: commenting out for now - badge will be introduced once notifications are supported
const useStyles = makeStyles((theme) => ({
	badge: {
		backgroundColor: cyan[400],
		borderColor: white[50],
		borderStyle: "solid",
		borderWidth: 1,
		borderRadius: 3,
		color: white[50],
		fontSize: 10,
		letterSpacing: -0.133333,
		minWidth: 12,
		padding: 1,
		textAlign: "center",

		// not sure why not 10, but this seems to works
		lineHeight: "8px",
	},

	container: {
		bottom: 2,
		height: 12,
		justifyContent: "center",
		left: 5,
		position: "absolute",
		width: 20,
	}
}));

<Box position="relative">
	<ChatBubbleIcon {...props} />
	<FlexRowCenter className={classes.container}>
		<Box className={classes.badge}>
			{totalNumberOfComments >= 100 ? "99+" : totalNumberOfComments}
		</Box>
	</FlexRowCenter>
</Box>
*/

export const CommentsIcon: FunctionComponent<SvgIconProps> = observer((props) => {
	const { commentsStore } = useStore();

	return commentsStore?.hasComments ?
		<ChatBubbleIcon {...props} />
		:
		<ChatBubbleOutlineIcon {...props} />
	;
});

export default CommentsIcon;

